module.exports = "<a ng-class=\"{ 'button' : isButton(), 'button-flat': isAdd()}\" ng-click=openShareMenu()> <div class=loading ng-if=loading> <div class=line></div> <div class=line></div> <div class=line></div> </div> <svg class=iconic ng-hide=loading> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + require("/var/app/node_modules/ushahidi-platform-pattern-library/assets/img/iconic-sprite.svg") + "#share></use> </svg> <span ng-class=\"{'button-label': isButton(), 'label': !isButton()}\" translate=app.share> Share {{isButton()}} </span> </a> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/views/share/post-share.html
// module id = 790
// module chunks = 0